import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { EventsService } from './eventsService';
import { AppConfigService } from './appConfigService';
import { MessageAlert } from '../_modals/message-alert/message-alert';
import { DataService } from './data.service';
import { DialogService } from './dialog.service';
import { AuthenticationService } from './authenticationService';
import { EnterPinFormComponent } from '../_modals/enter-pin-form/enter-pin-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

// This service kind of acts like interface for other controllers to show dialogs
// It knows lots about components at the moment, that can be moved to configs or respective services

@Injectable({
    providedIn: 'root'
})
export class AppDialogsService {

    public dialogImages = {
        success: {
            icon: 'fa fa-check-circle',
            color: 'green'
        },
        error: {
            icon: 'fa fa-times-circle',
            color: 'red'
        },
        warn: {
            icon: 'fa fa-exclamation-circle',
            color: 'orange'
        },
        star: {
            icon: 'star',
            color: '#1C367B'
        }

    };

    currentOpenModal: any;

    constructor(
        public popOverCntrl: PopoverController,
        private dataService: DataService,
        private dialogService: DialogService,
        private eventsService: EventsService,
        private appConfigService: AppConfigService,
        authService: AuthenticationService,
        private modalService: NgbModal,
        private translate: TranslateService
    ) {
        setTimeout(() => {
            authService.currentUser.subscribe(x => {
                if (this.currentOpenModal && !x) {
                    this.currentOpenModal.dismiss();
                }
            });
        }, 100);

    }

    private async showGenericMessageAlert(options?) {
        const modal = await this.popOverCntrl.create({
            component: MessageAlert,
            cssClass: options.cssClasses ? options.cssClasses : ['appFilterContainer'],
            backdropDismiss: options.canClose ? true : false,
            componentProps: {
                options: options
            },
        });
        modal.onDidDismiss()
            .then((result) => {
                if (options.cb) {
                    options.cb(result);
                }
                return result;
            });
        this.currentOpenModal = modal;
        return await modal.present();
    }

    showPayBalanceDialog(options) {
        const payMethod = options.data.isEloan ? 'CF' : 'IBP';
        return this.showGenericMessageAlert({
            icon: options.data.success ? this.dialogImages.success : this.dialogImages.error,
            html: options.data.success ? `${payMethod} is <strong>approved</strong>.</br>Your remaining ${payMethod} balance is <br/>${this.dataService.displayNumberAsCurrency(options.data.balance)}` :
                `Payable amount is more than ${payMethod} limit / balance. Your remaining ${payMethod} balance is <br/>${this.dataService.displayNumberAsCurrency(options.data.balance)}`,
            buttons: [
                { btnText: options.data.success ? 'PAY' : 'OK', btnClass: options.data.success ? '' : 'payButton' }
            ],
            cb: options.cb
        });
    }

    showPayTransactionStatus(options) {
        return this.showGenericMessageAlert({
            icon: options.data.resData.success ? this.dialogImages.success : this.dialogImages.error,
            header: options.data.resData.success ? 'Payment successful' : 'Payment failed',
            html: options.data.resData.success ? options.data.resData.message :
                'Your payment was unsucessful, please try again.<br/>If your account was debited, status will be updated in payment history in some time.',
            buttons: [
                { btnText: 'OK', btnClass: '' }
            ],
            cb: options.cb
        });
    }

    showIncorrectPinDialog(options) {
        return this.showGenericMessageAlert({
            icon: this.dialogImages.warn,
            html: options.html || this.translate.instant('LABELS.YOU_HAVE_ENTERED_AN_INCORRECT_TRANSACTION_PIN_AND_MADE_1_UNSUCCESSFUL_ATTEMPT(S)', { countOfIncorrectPinEntered : options.countOfIncorrectPinEntered}),
            buttons: [
                { btnText: this.translate.instant('LABELS.FORGOT_PIN'), btnClass: 'payButton' },
                { btnText: this.translate.instant('LABELS.OK'), btnClass: '' }
            ],
            cb: options.cb
        });
    }

    showFirstTimePinChange(options) {
        return this.showGenericMessageAlert({
            icon: this.dialogImages.warn,
            //html: `Welcome ${options.userName}. </br>Please change your pin first to access the app.`,
            html: `${this.translate.instant('LABELS.WELCOME')} ${this.translate.instant('LABELS.CUSTOMER')}, </br>${this.translate.instant('LABELS.PLEASE_UPDATE_YOUR_PIN_FIRST')}`,
            buttons: [
                { btnText: `${this.translate.instant('LABELS.OK')}`, btnClass: '' }
            ],
            cb: options.cb
        });
    }

    showCFBanner(bannerOptions) {
        return this.showGenericMessageAlert({
            icons: [this.dialogImages.star, this.dialogImages.star, this.dialogImages.star],
            header: bannerOptions.TITLE,
            html: bannerOptions.MSG,
            buttons: bannerOptions.actions.map((btn, nIndex) => {
                return {
                    btnText: btn.caption, btnClass: (nIndex === bannerOptions.actions.length - 1) ? 'payButton' : 'secondaryButton',
                    resolve: { action: btn.val, bannerOptions }
                };
            }),
            cssClasses: ['appFilterContainer', 'roundedPopOver'],
            addHeader: true,
            cb: bannerOptions.cb
        });
    }

    showSellerMessageToBuyer(msg) {
        return this.showGenericMessageAlert({
            icons: [this.dialogImages.warn],
            header: '',
            html: msg,
            buttons: [
                {
                    btnText: 'Close', btnClass: 'payButton', resolve: { action: '', cb: () => { } }
                }
            ],
            cssClasses: ['appFilterContainer', 'roundedPopOver'],
            addHeader: true,
            cb: () => { }
        });
    }

    showMessageForMultipayGroup(invoice, options) {
        return this.showGenericMessageAlert({
            icon: this.dialogImages.success,
            html: `Please select “Multi-pay with deductions” from the menu bar to Multi-pay Rieter invoices`,
            buttons: [
                { btnText: 'Close', btnClass: '' },
                { btnText: 'View Multi-pay Set', btnClass: 'payButton' },
            ],
            cb: options.cb
        });
    }

    showGenericError(options) {
        return this.showGenericMessageAlert({
            icon: this.dialogImages.error,
            html: options.htmlMsg,
            buttons: options.buttons || [
                { btnText: `${this.translate.instant('LABELS.OK')}`, btnClass: '' }
            ],
            cb: options.cb,
            canClose: options.canClose,
            autoCloseTime: options.autoCloseTime
        });
    }

    async openAppDialogPopOverCntrl(component, componentProps, cssClasses, onDismiss, size = 'lg') {
        const modal = await this.popOverCntrl.create({
            component: component,
            componentProps: componentProps,
            cssClass: cssClasses,
            backdropDismiss: false,
            keyboardClose: false,
            translucent: false
        });
        modal.onDidDismiss()
            .then((result) => {
                if (onDismiss) {
                    onDismiss(result);
                }
            });
        this.currentOpenModal = modal;
        return await modal.present();
    }

    openPinEnterDialog(options, onClose) {
        this.openAppDialogPopOverCntrl(EnterPinFormComponent, {
            options: options
        }, ['appFilterContainer'], (result) => {
            try {
                onClose(result.data);   
            } catch (error) {
                console.log("error : ", error);
            }
        });
    }


    /* App wide dialogs here */
    // async openAppDialog(component, componentProps, cssClasses, onDismiss) {
    //     const modal = await this.popOverCntrl.create({
    //         component: component,
    //         componentProps: componentProps,
    //         cssClass: cssClasses,
    //         backdropDismiss: false,
    //         keyboardClose: false,
    //         translucent: false
    //     });
    //     modal.onDidDismiss()
    //         .then((result) => {
    //             if (onDismiss) {
    //                 onDismiss(result);
    //             }
    //         });
    //     this.currentOpenModal = modal;
    //     return await modal.present();
    // }

    async openAppDialog(component, componentProps, cssClasses, onDismiss, size = 'lg') {
        const modalRef = this.modalService.open(component, { centered: true, size, backdrop:'static' });
        Object.keys(componentProps).forEach(key => {
            modalRef.componentInstance[key] = componentProps[key];    
        })
        return await modalRef.result;
        // const modal = await this.popOverCntrl.create({
        //     component: component,
        //     componentProps: componentProps,
        //     cssClass: cssClasses,
        //     backdropDismiss: false,
        //     keyboardClose: false,
        //     translucent: false
        // });
        // modal.onDidDismiss()
        //     .then((result) => {
        //         if (onDismiss) {
        //             onDismiss(result);
        //         }
        //     });
        // this.currentOpenModal = modal;
        //return await modal.present();
    }


    async openModal(component, componentProps, options: any = {}) {
        const modalRef = this.modalService.open(component, { centered: true, size: options.size || 'lg' });
        modalRef.componentInstance.payData = componentProps;
    }

    async closeAppDialog() {
        try {
            this.popOverCntrl.dismiss();
        } catch (err) {
        }
    }

    showInvalidLoginAttemptsWithPINDialog(options) {
        return this.showGenericMessageAlert({
            icon: this.dialogImages.warn,
           /* html: `You have entered an incorrect pin and made <strong>${options.count}</strong>
                    unsuccessful attempt(s).<br/>Please reset your pin to proceed.`,*/
            html: this.translate.instant('LABELS.YOU_HAVE_ENTERED_AN_INCORRECT_PIN_AND_MADE_3_UNSUCCESSFUL_ATTEMPT_PLEASE_RESET_YOUR_PIN_TO_PROCEED', { countOfIncorrectPinEntered : options.count}),
            buttons: [
                { btnText: `${this.translate.instant('LABELS.OK')}`, btnClass: 'payButton' },
            ],
            cb: options.cb
        });
    }

    showGenericSuccess(options) {
        return this.showGenericMessageAlert({
            icon: this.dialogImages.success,
            html:  options.msg || `${this.translate.instant('MESSAGES.YOUR_PAYMENT_HAS_BEEN_INITIATED_SUCCESSFULLY')}`,
            header: options.header,
            buttons: [
                { btnText: `${this.translate.instant('LABELS.CLOSE')}`, btnClass: '' },
            ],
            cb: options.cb
        });
    }

    showSessionTimeout(options) {
        this.showGenericError({
            htmlMsg: options.msg,
            canClose: true,
            buttons: [],
            autoCloseTime: environment.environmentConfig.POPUP_AUTO_CLOSE_TIMEOUT || 5000
        });
    }
}


